import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../store/configureStore";
import { LibraryItems } from "../../models/library";
import { BasketHistory, BasketHistoryDeatils, getProduct } from "../../axios";

interface ContactState {
  libraryLoaded: boolean;
  status: string;
}

const libraryAdapter = createEntityAdapter<LibraryItems>();

const phoneNumber = localStorage.getItem('phonenumber')

export const fetchLibraryAdapterAsync = createAsyncThunk<
  LibraryItems[],
  string,
  { state: RootState }
>("LibraryItems/fetchLibraryAdapterAsync", async (_, thunkAPI) => {
  try {
    const response = await BasketHistory(phoneNumber).then(({ data }) => {
      
      // Use Promise.all to wait for all the BasketHistoryDetails requests to finish
      return Promise.all(data.map((item: any) => BasketHistoryDeatils(item.id)))
        .then((results) => {                    
          // Use flatMap to flatten the nested arrays of data into one array
          return results.flatMap(({ data }) => data);
        })
        .then((newData) => {
          return Promise.all(
            newData.map((item: any) => getProduct(item.productID))
          ).then((data) => {
            return data.flatMap(({ data }) => data);
          });
        });
    });    
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({ error: error.data });
  }
});

export const LibraryItemsSlice = createSlice({
  name: "Contact",
  initialState: libraryAdapter.getInitialState<ContactState>({
    libraryLoaded: false,
    status: "idle",
  }),
  reducers: {
    setBlogContent: (state, action) => {
      libraryAdapter.upsertOne(state, action.payload);
      state.libraryLoaded = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLibraryAdapterAsync.pending, (state, action) => {
      state.status = "pendingFetchContact";
    });
    builder.addCase(fetchLibraryAdapterAsync.fulfilled, (state, action) => {
      libraryAdapter.setAll(state, action.payload);
      state.status = "idle";
      state.libraryLoaded = true;
    });
    builder.addCase(fetchLibraryAdapterAsync.rejected, (state, action) => {
      state.status = "idle";
    });
  },
});

export const librarySelectors = libraryAdapter.getSelectors(
  (state: RootState) => state.library
);

export const { setBlogContent } = LibraryItemsSlice.actions;
